import { render, staticRenderFns } from "./ZoomSlider.vue?vue&type=template&id=132fb53a&"
import script from "./ZoomSlider.vue?vue&type=script&lang=js&"
export * from "./ZoomSlider.vue?vue&type=script&lang=js&"
import style0 from "./ZoomSlider.vue?vue&type=style&index=0&id=132fb53a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports